import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private loaded = false;
  private loading = false;

  constructor() {}

  loadGoogleMaps(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loaded) {
        resolve();
        return;
      }

      if (this.loading) {
        // Wait for the loading to complete
        const checkLoaded = () => {
          if (this.loaded) {
            resolve();
          } else {
            setTimeout(checkLoaded, 100);
          }
        };
        checkLoaded();
        return;
      }

      this.loading = true;

      // Check if Google Maps is already loaded
      if (typeof google !== 'undefined' && google.maps) {
        this.loaded = true;
        this.loading = false;
        resolve();
        return;
      }

      // Create script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&loading=async&libraries=routes,marker&v=weekly`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.loaded = true;
        this.loading = false;
        resolve();
      };

      script.onerror = () => {
        this.loading = false;
        reject(new Error('Failed to load Google Maps API'));
      };

      // Append script to head
      document.head.appendChild(script);
    });
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  /**
   * Ensures Google Maps API is loaded, throws error if not
   * Use this method when you expect the API to already be loaded
   */
  ensureLoaded(): void {
    if (!this.loaded) {
      throw new Error('Google Maps API is not loaded. Make sure to load it during application startup.');
    }
  }
}